<template>
  <span>
    <BotPageTitle />
    <h3
      :style="{ fontSize: $vuetify.breakpoint.xsOnly ? '20px' : '' }"
      style="margin-top: 0; margin-bottom: 20px; padding: 0 15px;"
    >
      {{ $t("drawer.settings") }}
    </h3>
    <div class="md-layout">
      <div class="md-layout-item md-small-size-100">
        <md-card>
          <md-card-header class="md-card-header-icon md-card-header-green">
            <div class="card-icon">
              <md-icon>info</md-icon>
            </div>
            <h4 class="title">{{ $t("settings.about.title") }}</h4>
          </md-card-header>

          <md-card-content>
            <form class="form-horizontal" action="" method="post">
              <md-field>
                <label>{{ $t("settings.about.subitems.assistantName") }}</label>
                <md-input v-model="sobre.nome_assistente"></md-input>
              </md-field>

              <md-field>
                <label>{{ $t("settings.about.subitems.description") }}</label>
                <md-input v-model="sobre.descricao"></md-input>
              </md-field>
            </form>
          </md-card-content>
        </md-card>
      </div>
      <div class="md-layout-item md-small-size-100">
        <md-card>
          <md-card-header class="md-card-header-icon md-card-header-green">
            <div class="card-icon">
              <md-icon>email</md-icon>
            </div>
            <h4 class="title">{{ $t("settings.emailSettings.title") }}</h4>
          </md-card-header>

          <md-card-content>
            <form class="form-horizontal" action="" method="post">
              <md-field>
                <label>{{
                  $t("settings.emailSettings.subitems.smtpEmailServerURL")
                }}</label>
                <md-input v-model="email.url_servidor_email_smtp"></md-input>
              </md-field>

              <md-field>
                <label>{{
                  $t("settings.emailSettings.subitems.serverPort")
                }}</label>
                <md-input v-model="email.porta_servidor"></md-input>
              </md-field>

              <md-field>
                <label>{{
                  $t("settings.emailSettings.subitems.smtpServerAccessEmail")
                }}</label>
                <md-input v-model="email.email_acesso_smtp"></md-input>
              </md-field>

              <md-field>
                <label>{{
                  $t("settings.emailSettings.subitems.emailPassword")
                }}</label>
                <md-input v-model="email.senha_email"></md-input>
              </md-field>
            </form>
          </md-card-content>
        </md-card>
      </div>
    </div>

    <div class="md-layout">
      <div class="md-layout-item md-small-size-100">
        <md-card>
          <md-card-header class="md-card-header-icon md-card-header-green">
            <div class="card-icon">
              <md-icon>settings</md-icon>
            </div>
            <h4 class="title">{{ $t("settings.assistantSettings.title") }}</h4>
          </md-card-header>

          <md-card-content>
            <form class="form-horizontal" action="" method="post">
              <md-field>
                <label>{{
                  $t("settings.assistantSettings.subitems.certaintyRatio")
                }}</label>
                <md-input v-model="settings.grau_certeza"></md-input>
              </md-field>
            </form>
          </md-card-content>
        </md-card>
      </div>

      <div class="md-layout-item md-small-size-100">
        <md-card>
          <md-card-header class="md-card-header-icon md-card-header-green">
            <div class="card-icon">
              <md-icon>vpn_key</md-icon>
            </div>
            <h4 class="title">{{ $t("settings.credentials.title") }}</h4>
          </md-card-header>

          <md-card-content>
            <form class="form-horizontal" action="" method="post">
              <md-field>
                <label>
                  {{ $t("settings.credentials.subitems.watsonAPIUrl") }}</label
                >
                <md-input v-model="credentials.watson_api_url"></md-input>
              </md-field>

              <md-field>
                <label>{{ $t("settings.credentials.subitems.apiKey") }}</label>
                <md-input v-model="credentials.api_key"></md-input>
              </md-field>

              <md-field>
                <label>{{
                  $t("settings.credentials.subitems.assistantID")
                }}</label>
                <md-input v-model="credentials.assistant_id"></md-input>
              </md-field>

              <md-field>
                <label>{{
                  $t("settings.credentials.subitems.workspaceID")
                }}</label>
                <md-input v-model="credentials.workspace_id"></md-input>
              </md-field>
            </form>
          </md-card-content>
        </md-card>
      </div>
    </div>

    <div class="md-layout">
      <div class="md-layout-item">
        <md-button
          class="md-twitter"
          style="display: block; margin-left: auto; margin-right: auto;"
        >
          <span style="color: black">{{ $t("commonWords.save") }}</span>
        </md-button>
      </div>
    </div>
  </span>
</template>
<script>
import BotPageTitle from '@/components/BotPageTitle'
export default {
  components: { BotPageTitle },
  data () {
    return {
      sobre: {
        nome_assistente: 'EDS - Atendente Virtual',
        descricao: this.$t('settings.assistantsForUsers')
      },
      email: {
        url_servidor_email_smtp: '',
        porta_servidor: '',
        email_acesso_smtp: '',
        senha_email: ''
      },
      settings: {
        grau_certeza: '0.5'
      },
      credentials: {
        watson_api_url:
          'https://api.us-south.assistant.watson.cloud.ibm.com/instances/53e31d19-fff2-4d4e-95d3-4805c16390d8',
        api_key: '7LGesv_V7DxWc5XEjnDmopFUQBop16qKcZO14VOgDX8v',
        assistant_id: '0d1cc0ee-c042-46fe-bd57-7bd0597a3d4e',
        workspace_id: '773dccff-e8c5-42d3-9ad2-b4d9aef186f0'
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.md-card .md-card-actions {
  border: none;
}

.md-inline-checkboxes {
  display: inline-flex;

  .md-checkbox {
    margin-top: 15px !important;
  }
}

.md-checkbox,
.md-radio {
  margin-top: 15px;
  margin-bottom: 0.5rem;
}

.md-checkbox,
.md-radio {
  display: flex;
}

.md-radio .md-radio-container {
  margin-left: 5px;
  position: relative;
  left: -3px;
}

.md-form-label + .md-layout-item .md-checkbox:not(:first-child),
.md-form-label + .md-layout-item + .md-layout-item .md-radio:not(:first-child),
.md-form-label + .md-layout-item .md-radio {
  margin-top: 0;
}

.form-control-static {
  margin-top: 6px;
}
</style>
